<div fxLayout="column">
    <div>
        <button kendoButton (click)="add()" look="outline" icon="plus">{{'claims-center.claimDocumentation.addProof'
            | translate}}</button>
    </div>

    <kendo-grid [data]="proofDocuments$ | async" [loading]="isLoading" [size]="'small'">

        <kendo-grid-column field="name" title="{{'claims-center.claimDocumentation.proofDocumentType' | translate}}"
            [width]="100" media="(min-width: 1008px)">
            <ng-template kendoGridCellTemplate let-proof="dataItem">
                <div fxLayout="row">
                    <div fxLayout="column">
                        <strong>{{ proof.typeId | staticDictionaryCaption:'proofDocumentType' |async }}</strong>
                    </div>
                </div>
            </ng-template>
        </kendo-grid-column>

         <kendo-grid-column field="actions" title="" [width]="60" media="(min-width: 1008px)">
            <ng-template kendoGridCellTemplate let-proof="dataItem">
                <div fxLayout="row">
                    <button kendoButton look="flat" icon="edit" (click)="edit(proof)"> </button>
                    <button kendoButton look="flat" icon="delete" (click)="remove(proof)"> </button>
                    <button *ngIf="proof.conformityId !== 2" kendoButton look="flat" icon="check"
                        (click)="approve(proof)"> </button>

                </div>
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="linkedDocument"
            title="{{'claims-center.claimDocumentation.linkedDocument' | translate}}" [width]="60" autosize="true"
            media="(min-width: 1008px)">
            <ng-template kendoGridCellTemplate let-proof="dataItem">
                <button *ngIf="proof.linkedClaimDocumentCount > 0" kendoButton look="flat" icon="clip"
                    (click)="showLinkedDocs(proof)"> </button>
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="requiredFrom"
            title="{{'claims-center.claimDocumentation.proofDocumentRequiredFrom' | translate}}" [width]='40'
            media="(min-width: 1008px)">
            <ng-template kendoGridCellTemplate let-proof="dataItem">
                <div fxLayout="row">
                    <div fxLayout="column">
                        <strong>{{ proof.requiredFrom | staticDictionaryCaption:'proofDocumentRequiredFrom' |async
                            }}</strong>
                    </div>
                </div>

            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="proofDocumentKind"
            title="{{'claims-center.claimDocumentation.proofDocumentKind' | translate}}" [width]='60'
            media="(min-width: 1008px)">
            <ng-template kendoGridCellTemplate let-proof="dataItem">
                <div fxLayout="row">
                    <div fxLayout="column">
                        <strong>{{ proof.kindId | staticDictionaryCaption:'proofDocumentKind' |async }}</strong>
                    </div>
                </div>

            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="proofDocumentConformity"
            title="{{'claims-center.claimDocumentation.proofDocumentConformity' | translate}}" [width]="60"
            media="(min-width: 1008px)">
            <ng-template kendoGridCellTemplate let-proof="dataItem">
                <div fxLayout="row">
                    <div fxLayout="column">
                        <strong [ngClass]="proof.conformityId === 2 ? 'conformed' : 'non-conformed' ">
                            {{ proof.conformityId | staticDictionaryCaption:'proofDocumentConformity' |async }}
                        </strong>
                    </div>
                </div>

            </ng-template>
        </kendo-grid-column>


        <kendo-grid-column field="createdBy" title="{{'claims-center.claimDocumentation.createdBy' | translate}}"
            [width]="60" media="(min-width: 1008px)">
            <ng-template kendoGridCellTemplate let-proof="dataItem">
                <span>{{proof.createdBy }}</span>
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="timestamp" title="{{'claims-center.claimDocumentation.timestamp' | translate}}"
            [width]="60" media="(min-width: 1008px)">
            <ng-template kendoGridCellTemplate let-proof="dataItem">
                <span>{{proof.timestamp | date:'yyyy-MM-dd HH:mm:ss' }}</span>
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="description" title="{{'claims-center.claimDocumentation.description' | translate}}"
            [width]='120' autosize="true" media="(min-width: 1008px)">
            <ng-template kendoGridCellTemplate let-proof="dataItem">
                <span>{{proof.description }}</span>
            </ng-template>
        </kendo-grid-column>


        <!-- Mobile view for proofs -->
        <kendo-grid-column title="" media="(max-width: 1007px)" class="mobile-grid-column">
            <ng-template kendoGridCellTemplate let-proof="dataItem">
                <div fxLayout="column" class="form-block mobile-grid-column-item">

                    <div fxLayout="row wrap" fxLayoutGap="3px" fxLayoutAlign="start center">
                        <div fxFlex="43">
                            {{'claims-center.claimDocumentation.proofDocumentType' | translate}}
                        </div>

                        <div fxFlex="45" fxLayout="column">
                            <strong>{{ proof.typeId | staticDictionaryCaption:'proofDocumentType' |async }}</strong>
                        </div>
                    </div>

                    <div fxLayout="row wrap" fxLayoutGap="3px" fxLayoutAlign="start center">
                        <div fxFlex="43">
                            {{'claims-center.claimDocumentation.linkedDocument' | translate}}
                        </div>

                        <div fxFlex="45" fxLayout="column">
                            <button *ngIf="proof.linkedClaimDocumentCount > 0" kendoButton look="flat" icon="clip"
                                (click)="showLinkedDocs(proof)"> </button>
                        </div>
                    </div>

                    <div fxLayout="row wrap" fxLayoutGap="3px" fxLayoutAlign="start center">
                        <div fxFlex="43">
                            {{'claims-center.claimDocumentation.proofDocumentRequiredFrom' | translate}}
                        </div>

                        <div fxFlex="45" fxLayout="column">
                            <strong>{{ proof.requiredFrom | staticDictionaryCaption:'proofDocumentRequiredFrom' |async
                                }}</strong>
                        </div>
                    </div>

                    <div fxLayout="row wrap" fxLayoutGap="3px" fxLayoutAlign="start center">
                        <div fxFlex="43">
                            {{'claims-center.claimDocumentation.proofDocumentKind' | translate}}
                        </div>

                        <div fxFlex="45" fxLayout="column">
                            <strong>{{ proof.kindId | staticDictionaryCaption:'proofDocumentKind' |async }}</strong>
                        </div>
                    </div>

                    <div fxLayout="row wrap" fxLayoutGap="3px" fxLayoutAlign="start center">
                        <div fxFlex="43">
                            {{'claims-center.claimDocumentation.proofDocumentConformity' | translate}}
                        </div>

                        <div fxFlex="45" fxLayout="column">
                            <strong [ngClass]="proof.conformityId === 2 ? 'conformed' : 'non-conformed' ">
                                {{ proof.conformityId | staticDictionaryCaption:'proofDocumentConformity' |async }}
                            </strong>
                        </div>
                    </div>

                    <div fxLayout="row wrap" fxLayoutGap="3px" fxLayoutAlign="start center">
                        <div fxFlex="43">
                            {{'claims-center.claimDocumentation.timestamp' | translate}}
                        </div>

                        <div fxFlex="45" fxLayout="column">
                            <span>{{proof.timestamp | date:'yyyy-MM-dd HH:mm:ss' }}</span>
                            <span>{{proof.createdBy }}</span>
                        </div>
                    </div>

                    <div fxLayout="row wrap" fxLayoutGap="3px" fxLayoutAlign="start center">
                        <div fxFlex="43">
                            {{'claims-center.claimDocumentation.description' | translate}}
                        </div>

                        <div fxFlex="45" fxLayout="column">
                            <span>{{proof.description }}</span>
                        </div>
                    </div>

                    <div fxLayout="row wrap" fxLayoutGap="3px" fxLayoutAlign="start center">
                        <div fxFlex="98" fxLayout="row-wrap">
                            <button kendoButton look="flat" icon="edit" (click)="edit(proof)"> </button>
                            <button kendoButton look="flat" icon="delete" (click)="remove(proof)"> </button>
                            <button *ngIf="proof.conformityId !== 2" kendoButton look="flat" icon="check"
                                (click)="approve(proof)"> </button>
                        </div>
                    </div>

                </div>
            </ng-template>
        </kendo-grid-column>

    </kendo-grid>
</div>

<div kendoDialogContainer #proofDocsDialog></div>